import { Injectable } from '@angular/core';
import {FormbirdInjectorService} from '../injector/formbird-injector.service';
declare const angular: any;


@Injectable({
  providedIn: 'root'
})
export class WebSocketService {

  ajsService: any;

  constructor(private injector: FormbirdInjectorService) {
    this.ajsService = injector.get('WebSocketService');
  }

  emit(eventName, data) {
    return this.ajsService.emit(eventName, data);
  }

  addEventListener(eventName, eventHandlerFunc) {
    return this.ajsService.addEventListener(eventName, eventHandlerFunc);
  }

  removeEventListener(eventName) {
    return this.ajsService.removeEventListener(eventName);
  }
}
